import TasksView_Settings from "../settings"
import {TasksViewAppSettings} from "../../@types"
import {AppSettingsMode, DEFAULT_TEMPLATE_ID} from "../../../../../manager/app-settings/app-settings"
import ViewTemplates from "../../../../../manager/view-templates/view-templates"
import ProjectViewAppSettingsLookup from "../../../../../model2/project/inheritance/project-settings";

// const debug = "tasksView_Settings_getActualConfig"
const debug = false

export default function tasksView_Settings_getActualConfig(settings: TasksView_Settings, appSettingsConfig?: TasksViewAppSettings): TasksViewAppSettings | undefined {

    // view config (stored)
    // localSettings
    // templateId
    // inherited

    // 1. LOCAL
    // work with local ...
    //      templateId ? -> use It
    //      use config

    // 2. STORED
    // work with stored
    //      templateId ? -> use It
    //      use config

    // 3. NO LOCAL NO STORED
    // use inherited
    // use default


    /** --- LOCAL --- **/
    debug && console.log(debug, 'process local', settings.localSettings.appSettings)

    if (settings.localSettings.appSettings) {

        debug && console.log(debug, 'process local templateId', settings.localSettings.appSettings.templateId)

        // we work with local
        if (settings.localSettings.appSettings.templateId) {
            // deal with template
            const templateBasedSettings = getConfigFromTemplate(settings, settings.localSettings.appSettings)
            if (templateBasedSettings) {
                settings._mode          = AppSettingsMode.TEMPLATE
                settings._templateId    = settings.localSettings.appSettings.templateId
                return templateBasedSettings
            }
        }

        settings._mode = AppSettingsMode.CUSTOM
        return settings.localSettings.appSettings
    }

    debug && console.log(debug, 'process stored', appSettingsConfig)

    /** --- STORED --- **/
    if (appSettingsConfig) {

        debug && console.log(debug, 'process stored templateId', appSettingsConfig.templateId)

        // work with stored
        if (appSettingsConfig.templateId) {
            // deal with template
            const templateBasedSettings = getConfigFromTemplate(settings, appSettingsConfig)
            if (templateBasedSettings) {
                settings._mode          = AppSettingsMode.TEMPLATE
                settings._templateId    = appSettingsConfig.templateId
                return templateBasedSettings
            }
        }

        settings._mode = AppSettingsMode.CUSTOM
        return appSettingsConfig
    }

    /** --- INHERITED --- **/
    debug && console.log(debug, 'process inherited', settings.shouldInheritAppSettings, settings.projectId)

    // Check inheritance
    // check if view is project based
    // findParentConfig ... projectId ... .....
    // used it
    if (settings.shouldInheritAppSettings && settings.projectId) {
        const projectViewAppSettingsLookup = new ProjectViewAppSettingsLookup(settings.projectId)
        let appSettings: TasksViewAppSettings | undefined

        if (gd.projectViews.currentView.isInherited) {
            // if view is inherited try to find app settings config from parent view
            appSettings = projectViewAppSettingsLookup.get(gd.projectViews.currentView.id, true) || undefined
        } else {
            // if view is not inherited try to find app settings config from parent by its type (take first matching view)
            appSettings = projectViewAppSettingsLookup.getByType(gd.projectViews.currentView.type, true) || undefined
        }

        debug && console.log(debug, 'process inherited appSettings', appSettings)

        // if inherited settings config is found save its origin
        if (projectViewAppSettingsLookup.sourceProjectId) {
            settings._inheritedFromProject = gd.session.projects.get(projectViewAppSettingsLookup.sourceProjectId)
        }

        // if nothing found then there are default settings, skip return
        if (appSettings) {
            if (appSettings?.templateId) {
                // deal with template
                const templateBasedSettings = getConfigFromTemplate(settings, appSettings)
                if (templateBasedSettings) {
                    settings._mode          = AppSettingsMode.INHERITED
                    settings._templateId    = appSettings.templateId
                    return templateBasedSettings
                }
            }

            settings._mode = AppSettingsMode.INHERITED
            return _.cloneDeep(appSettings)
        }
    }

    /** --- DEFAULT --- **/
    debug && console.log(debug, 'process default template')

    // use DEFAULT template
    const defaultTemplate = getConfigFromTemplate(settings, {templateId: DEFAULT_TEMPLATE_ID})
    if (defaultTemplate) {
        settings._mode          = AppSettingsMode.TEMPLATE
        settings._templateId    = DEFAULT_TEMPLATE_ID
        return defaultTemplate!
    }

    /** --- FALLBACK DEFAULT --- **/
    debug && console.log(debug, 'process fallback default')

    // use fallback default settings
    return settings.defaultAppSettings

    // // 1. start with user's local settings if present, otherwise fallback to passed-in config or empty object
    // let actualConfig: TasksViewAppSettings = settings.localSettings.appSettings || appSettingsConfig || {}
    //
    // debug && console.log(debug, 'process', settings.inheritAppSettings, actualConfig, appSettingsConfig)
    //
    // // 2. handle local inheritance mode
    // let resolvedTemplateId: ID | undefined = actualConfig.templateId
    //
    // // if localSettings.appSettings.templateId is LOCAL_INHERITED_TEMPLATE_ID and inheritAppSettings is true
    // // then we need to load inherited appSettings ignoring passed appSettingsConfig
    // // (found no other way to implement local inherited settings)
    // if (
    //     resolvedTemplateId === LOCAL_INHERITED_TEMPLATE_ID &&
    //     settings.inheritAppSettings
    // ) {
    //     // load inherited settings (should be overridden in subclasses)
    //     actualConfig     = settings.getInheritedAppSettings() || {}
    // }
    //
    // // 3. determine which templateId (if any) to use
    // // if config has a templateId, use that, otherwise use a default
    // if (actualConfig) {
    //     resolvedTemplateId = actualConfig.templateId
    // } else {
    //     resolvedTemplateId = DEFAULT_TEMPLATE_ID
    // }
    //
    // // 4. if a template is specified get template config and merge any ignored params from appSettingsConfig
    // if (resolvedTemplateId) {
    //     // collect the fields from appSettingsConfig that are supposed to be
    //     // ignored by the template and stored separately (in templateIgnoredParams, e.g. 'defaultZoom' for Gantt)
    //     const notInTemplate = _.pick(appSettingsConfig, settings.templateIgnoredParams)
    //
    //     // lookup template app setting by system type and templateId
    //     const template = new ViewTemplates().getTemplate(settings.systemType, resolvedTemplateId)
    //
    //     if (template?.appSettings) {
    //         // merge template settings with the ignored fields, preferring the ignored
    //         actualConfig = _.assign({}, template.appSettings, notInTemplate)
    //     }
    // }
    //
    // debug && console.log(debug, 'process result', actualConfig)
    //
    // return actualConfig
}

function getConfigFromTemplate(settings:TasksView_Settings, settingsConfig: TasksViewAppSettings):TasksViewAppSettings | false {

    // lookup template app setting by system type and templateId
    const template = new ViewTemplates().getTemplate(settings.systemType, settingsConfig.templateId!)

    debug && console.log(debug, 'getConfigFromTemplate', settings.systemType, settingsConfig.templateId, template)

    if (!template) {
        return false
    }

    // collect the fields from appSettingsConfig that are supposed to be
    // ignored by the template and stored separately (in templateIgnoredParams, e.g. 'defaultZoom' for Gantt)
    const notInTemplate : DictionaryStringAny = _.pick(settingsConfig, settings.templateIgnoredParams)

    // merge template settings with the ignored fields, preferring the ignored
    let actualConfig = _.cloneDeep(template.appSettings)
    actualConfig = _.assign(actualConfig, notInTemplate)
    return actualConfig

}